import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../components/motion";
import { CtaBand } from "../components/shared";
import { CONTACT } from "../data/site";

export default function Privacy() {
  return (
    <>
      <section className="sec" style={{ paddingTop: 140 }} data-testid="privacy-page">
        <div className="wrap" style={{ maxWidth: 900 }}>
          <Reveal>
            <p className="kick">Privacy</p>
            <h1 className="h2" style={{ marginBottom: 34 }}>Privacy Policy</h1>
          </Reveal>
          <Reveal delay={0.05}>
            <div style={{ color: "var(--muted)", display: "grid", gap: 22 }} data-testid="privacy-content">
              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Titolare del trattamento</p>
              <p style={{ margin: 0 }}>
                Orion Security Srl – Via Prusst snc, 00030 San Cesareo (RM) – P.IVA 18377831005. Email: {CONTACT.email} – Telefono: {CONTACT.phone}.
              </p>
              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Dati raccolti</p>
              <p style={{ margin: 0 }}>
                Attraverso il form di richiesta preventivo raccogliamo esclusivamente i dati che decidi di comunicarci: nome, eventuale azienda, città, telefono, indirizzo email e messaggio. La richiesta non viene conservata nel sito: viene inviata via email all'ufficio commerciale e usata esclusivamente per risponderti e organizzare l'eventuale sopralluogo. Lo stesso vale per le segnalazioni e i reclami inviati dal form della pagina Contatti: se non lasci i tuoi contatti, la segnalazione resta anonima. Il telefono e la chat con l'assistente AI sono gestiti da un assistente virtuale, che raccoglie le indicazioni necessarie a farti richiamare da un nostro ufficio.
              </p>
              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Finalità e base giuridica</p>
              <p style={{ margin: 0 }}>
                I dati sono trattati per rispondere alla tua richiesta e contattarti in merito ai servizi richiesti. La base giuridica è il consenso espresso, che presti selezionando la casella dedicata nel form, e l'esecuzione di misure precontrattuali su tua richiesta (art. 6, par. 1, lett. a e b del Regolamento UE 2016/679).
              </p>
              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Conservazione</p>
              <p style={{ margin: 0 }}>
                I dati delle richieste restano solo nella casella di posta elettronica dell'ufficio commerciale, per il tempo necessario alla gestione della richiesta e, se nasce un rapporto commerciale, secondo gli obblighi di legge applicabili. In mancanza, le email vengono cancellate entro 12 mesi.
              </p>
              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Diritti dell'interessato</p>
              <p style={{ margin: 0 }}>
                Puoi chiedere in qualsiasi momento l'accesso ai tuoi dati, la rettifica, la cancellazione, la limitazione del trattamento, l'opposizione e la portabilità scrivendo a {CONTACT.email}. Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali.
              </p>
              <p style={{ margin: 0, fontWeight: 700, color: "var(--text)" }}>Nessuna profilazione</p>
              <p style={{ margin: 0 }}>
                Questo sito non utilizza cookie di profilazione né strumenti di tracciamento di terze parti. Vedi la <Link to="/cookie">Cookie Policy</Link>.
              </p>
              <p style={{ margin: 0, fontSize: 14 }}>Ultimo aggiornamento: ottobre 2026</p>
            </div>
          </Reveal>
        </div>
      </section>
      <CtaBand testid="privacy-cta" />
    </>
  );
}
